<app-served-categories *ngIf="categoryMultiCtrl" [categories]="categories" [categoryMultiCtrl]="categoryMultiCtrl"
    [title]="servedCategories" [noSelectedCategories]="noSelectedCategories" [displayCategories]="true">
</app-served-categories>
